import { jsx as _jsx } from "react/jsx-runtime";
import { CYPRESS_BYPASS_COVERAGE_KEY } from '@account-services-mfe/core';
import DebtCancellationLinkContainer from './subcomponent';
const PaymentSecurityLink = ({ children, href }) => {
    return (_jsx(DebtCancellationLinkContainer, { className: CYPRESS_BYPASS_COVERAGE_KEY, "data-analytics": "clicktrackingevent", "data-object": "link", "data-type": "payment security", "data-cy": "payment-security-link", "data-reason": "cancellation program agreement", rel: "noopener noreferrer", target: "_blank", href: href, isInline: true, children: children }));
};
export default PaymentSecurityLink;
